import { render, staticRenderFns } from "./basicAllowanceList.vue?vue&type=template&id=21cf61d2&scoped=true&"
import script from "./basicAllowanceList.vue?vue&type=script&lang=js&"
export * from "./basicAllowanceList.vue?vue&type=script&lang=js&"
import style0 from "./basicAllowanceList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./basicAllowanceList.vue?vue&type=style&index=1&id=21cf61d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf61d2",
  null
  
)

export default component.exports